import { render, staticRenderFns } from "./vip_code.vue?vue&type=template&id=6440472e&"
import script from "./vip_code.vue?vue&type=script&lang=js&"
export * from "./vip_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports